// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w19aXMOir2VZJKRqTR7Q{padding:12px 8px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/ui/EnterAddressCommon/ui/styles.module.scss"],"names":[],"mappings":"AAGA,sBACE,gBAAA","sourcesContent":[".wrap {\n}\n\n.statePlaceholder {\n  padding: 12px 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statePlaceholder": `w19aXMOir2VZJKRqTR7Q`
};
export default ___CSS_LOADER_EXPORT___;
